
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Getting Started`}</h2>
    <p><inlineCode parentName="p">{`styled-components`}</inlineCode>{` utilises tagged template literals to style your components.`}</p>
    <p>{`It removes the mapping between components and styles. This means that when you're defining your styles, you're actually creating a normal React component, that has your styles attached to it.`}</p>
    <p>{`This example creates two simple components, a wrapper and a title, with some styles attached to it:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`// Create a Title component that'll render an <h1> tag with some styles
const Title = styled.h1\`
  font-size: 1.5em;
  text-align: center;
  color: palevioletred;
\`;

// Create a Wrapper component that'll render a <section> tag with some styles
const Wrapper = styled.section\`
  padding: 4em;
  background: papayawhip;
\`;

// Use Title and Wrapper like any other React component – except they're styled!
render(
  <Wrapper>
    <Title>
      Hello World!
    </Title>
  </Wrapper>
);
`}</code></pre>
    <p>{`This is a live editor, so play around with the code to get a feel for what it's like to work with styled-components!`}</p>
    <blockquote>
      <p parentName="blockquote">{`The CSS rules are automatically vendor prefixed, styled-components takes care of that for you!`}</p>
      <p parentName="blockquote">{`Styled components uses `}<a parentName="p" {...{
          "href": "https://stylis.js.org/"
        }}>{`stylis.js`}</a>{` package under the hood for prefixing the css rules.`}</p>
      <p parentName="blockquote">{`For additional information about the supported prefixes in stylis.js visit their `}<a parentName="p" {...{
          "href": "https://github.com/thysultan/stylis.js"
        }}>{`repository`}</a>{`.`}</p>
    </blockquote>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;